export function useCartDataProvider(providerId) {
	let isGuest = true;
	let isFastBuy = true;
	let isFakePayment = false;

	const $cartDataProvider = document.getElementById(providerId);
	if (!$cartDataProvider) throw new Error(`Не удалось найти #${providerId}`);
	isGuest = !!$cartDataProvider.dataset.isGuest;
	isFastBuy = !!$cartDataProvider.dataset.isFastBuy;
	isFakePayment = !!$cartDataProvider.dataset.isFake;

	return {
		isGuest,
		isFastBuy,
		isFakePayment,
	};
}
